import { default as __ui_components_Dummy_component__ } from '../src/ui/components/Dummy/component';
import { default as __ui_components_Dummy_template__ } from '../src/ui/components/Dummy/template';
export default {'component:/dummy/components/Dummy': __ui_components_Dummy_component__,'template:/dummy/components/Dummy': __ui_components_Dummy_template__};
